export const LightTheme = {
    token: {
        colorPrimary: "#c70039",
        colorSecondary: "#003399",
        colorInfo: "#c70039",
        secondaryColor: "#003399",
        fontFamily: "Inter"
    },
    colorText: "#1D1D1F"
}